// app-src-react/app/index.js
import React from 'react';
import AppRoutes from './router';

const App = () => {
  return (
    <AppRoutes />
  );
};

export default App;